import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { verifyDeviceAuthToken } from "./schema/auth/verify-device-auth-token";
import { enableDeviceAuth } from "./schema/device-auth/enable-device-auth";
import { listDeviceAuth } from "./schema/device-auth/list-device-auth";
import { refreshDeviceToken } from "./schema/device-auth/refresh-device-token";
import { revokeDeviceAuth } from "./schema/device-auth/revoke-device-auth";
import { requestEmailOtp } from "./schema/otp/request-email-otp";
import { verifyEmailOtp } from "./schema/otp/verify-email-otp";
import { requestPasswordLogin } from "./schema/password/request-password-login";
import { verifyPassword } from "./schema/password/verify-password";

// Group related endpoints
const authEndpoints = { verifyDeviceAuthToken };
const deviceAuthEndpoints = {
  enableDeviceAuth,
  listDeviceAuth,
  revokeDeviceAuth,
  refreshDeviceToken,
};
const otpEndpoints = { requestEmailOtp, verifyEmailOtp };
const passwordEndpoints = { requestPasswordLogin, verifyPassword };

export const rpcDefinition = {
  ...authEndpoints,
  ...deviceAuthEndpoints,
  ...otpEndpoints,
  ...passwordEndpoints,
};

export type AuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
